import styled from '@emotion/styled';

import { OutlineButton } from '@/components/common/Button/style';
import { TablePanel } from '@/components/common/Panel/style';
import { pageSectionLayout } from '@/styles/pageLayout';

export { TablePanel };

export const Container = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 8rem;
`;
export const SectionTitle = styled.h2`
	margin: 0;
	font-size: ${({ theme }) => theme.fontSize.sizeXl};
	font-weight: ${({ theme }) => theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: ${({ theme }) => theme.ui.text.primary};
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	margin: 0 auto;
`;
export const NoticeBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.6rem;
	padding: 3.2rem 4rem;
	background-color: #f8f9fa;
	text-align: center;
	@media screen and (max-width: 900px) {
		padding: 2.8rem 2rem;
	}
`;
export const NoticeTitle = styled.h3`
	color: #212529;
	font-size: 2rem;
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const NoticeDescription = styled.p`
	max-width: 72rem;
	color: #495057;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.loose};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	word-break: keep-all;
`;
export const ContentItems = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	width: 100%;
	margin: 0 auto;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const ContentListLayout = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: start;
	gap: 0.4rem;
`;
export const ContentTitleSub = styled.p`
	color: #212529;
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 600;
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const ContentDescription = styled.p`
	color: var(--Colors-Font---color-font-darker, #212529);
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 400;
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;

export const Table = styled.div`
	display: grid;
	grid-auto-rows: minmax(40px, auto);
	white-space: nowrap;
	overflow: auto;
	gap: 0.2rem;
	&.table1 {
		grid-template-columns: 1fr 3fr;
	}
	&.table2 {
		grid-template-columns: 1fr 1fr 1fr 1fr;
		grid-template-areas:
			'item1 item2 item3 item4'
			'item5 item6 item7 item8';
		@media screen and (max-width: 900px) {
			grid-template-columns: 1fr 4fr;
			grid-template-areas:
				'item1 item5'
				'item2 item6'
				'item3 item7'
				'item4 item8';
		}
	}
	&.table3 {
		grid-template-columns: 1fr 3fr 3fr;
	}
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 10px 15px;
	text-align: left;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: ${(props) => props.theme.lineHeight.normal};
	&.center {
		justify-content: center;
	}
`;
export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 2rem 1.6rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	&.point {
		color: ${(props) => props.theme.colors.primary400};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
		text-align: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;
export const TableCellLayout = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1.2rem;
`;
export const Button = styled(OutlineButton)`
	width: max-content;
	min-width: 18rem;

	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;
export const GuideBox = styled.div`
	display: flex;
	flex-direction: column;
`;
export const GuideTextStrong = styled.p`
	color: ${(props) => props.theme.colors.red600};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const GuideText = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const CenterNotice = styled.p`
	padding: 1.6rem 0 0.8rem;
	color: #343a40;
	font-size: 2rem;
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.lineHeight.normal};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	text-align: center;
	word-break: keep-all;
	@media screen and (max-width: 900px) {
		font-size: 1.8rem;
	}
`;
export const InfoGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 0.2rem;
	@media screen and (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;
export const InfoCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	min-height: 9.6rem;
	padding: 1.6rem;
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
`;
export const InfoTitle = styled.h4`
	color: ${(props) => props.theme.colors.primary400};
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const InfoText = styled.p`
	color: #343a40;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	word-break: keep-all;
`;
